import { AxiosResponse } from "axios";
import API from "../api";

import { Carton, CartonView } from "../models/carton";

const ROUTE_NAME = "cartons";

const CartonService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Carton>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Carton[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(carton: Carton): Promise<AxiosResponse<Carton>> {
    return await API.post(`/${ROUTE_NAME}`, carton);
  },
  async update(id: number, carton: Carton): Promise<AxiosResponse<boolean>> {
    return await API.put(`${ROUTE_NAME}/${id}`, carton);
  },
  async generateLog(shipmentId: number): Promise<AxiosResponse<any>> {
    return await API.get(`${ROUTE_NAME}/log/${shipmentId}`);
  },
};

export default CartonService;
